import { isDarkMode } from "../../../utils/constants";

export const getChartPalette = () => {
  if (isDarkMode) {
    return {
      background: "#0d1117",
      text: "#cbd5e1",
      mutedText: "#94a3b8",
      border: "rgba(148, 163, 184, 0.24)",
      grid: "rgba(148, 163, 184, 0.12)",
      crosshair: "rgba(226, 232, 240, 0.26)",
      line: "#7aa2ff",
      up: "#21c58e",
      down: "#ef5f6b",
      entry: "#60a5fa",
      target: "#4ade80",
      stop: "#f87171",
      extendedHours: "#F5C84B",
      extendedHoursText: "#111827",
      premarketFill: "rgba(245, 200, 75, 0.09)",
      afterhoursFill: "rgba(245, 158, 11, 0.1)",
      sessionDivider: "rgba(148, 163, 184, 0.28)",
    };
  }

  return {
    background: "#f8fafc",
    text: "#475569",
    mutedText: "#64748b",
    border: "rgba(100, 116, 139, 0.18)",
    grid: "rgba(100, 116, 139, 0.12)",
    crosshair: "rgba(30, 41, 59, 0.18)",
    line: "#2563eb",
    up: "#16a34a",
    down: "#dc2626",
    entry: "#2563eb",
    target: "#16a34a",
    stop: "#dc2626",
    extendedHours: "#D99A00",
    extendedHoursText: "#111827",
    premarketFill: "rgba(217, 154, 0, 0.08)",
    afterhoursFill: "rgba(217, 119, 6, 0.1)",
    sessionDivider: "rgba(71, 85, 105, 0.22)",
  };
};
